import { render, staticRenderFns } from "./OutcomesCollapsableItem.vue?vue&type=template&id=60658525&"
import script from "./OutcomesCollapsableItem.vue?vue&type=script&lang=js&"
export * from "./OutcomesCollapsableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports